import { IonApp, IonContent, IonPage, IonRouterOutlet } from "@ionic/react";
import { IonReactRouter } from "@ionic/react-router";
import type { FC } from "react";
import React from "react";
import { Route } from "react-router-dom";

import { NotFoundView } from "@react/foundation/placeholder";
import { PageContainer } from "@react/ionic/app";
import { TooltipProvider } from "@react/ui-primitives/tooltip";

import { router } from "./bootstrap/router.ts";
import { AuthCallbackView, AuthGuard } from "./features/auth/index.ts";
import { ConfigProvider } from "./features/config/index.ts";
import { Home } from "./routes/Home.tsx";

export const App: FC = () => (
  <TooltipProvider>
    <IonApp>
      <IonReactRouter
        future={{ v7_relativeSplatPath: true, v7_startTransition: true }}
      >
        <IonRouterOutlet>
          <Route
            element={
              <PageContainer>
                <AuthCallbackView />
              </PageContainer>
            }
            path={router.getPattern("AuthCallback")}
          />
          <Route
            element={
              <IonPage>
                <IonContent scrollY={false}>
                  <AuthGuard>
                    <ConfigProvider>
                      <Home />
                    </ConfigProvider>
                  </AuthGuard>
                </IonContent>
              </IonPage>
            }
            path={router.getPattern("Home")}
          />
          <Route
            element={
              <PageContainer>
                <NotFoundView />
              </PageContainer>
            }
            path="*"
          />
        </IonRouterOutlet>
      </IonReactRouter>
    </IonApp>
  </TooltipProvider>
);
